export default __webpack_public_path__ + "static/media/notification_simple-01.f916f0cd.ogg";